// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ddbab1f8","806":"269ec6b4"}[chunkId] + ".chunk.js";
};